const useLog = () => {
  const loggingOn = false;
  const log = loggingOn ? console.log : () => {};
  return {
    log
  };
};
export { useLog };
//# sourceMappingURL=useLog.js.map